import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctorProfile } from 'Redux/modules/doctor/actions';

const useDoctorProfile = () => {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.doctors.profile);

  useEffect(() => {
    dispatch(getDoctorProfile());
  }, [dispatch]);

  return {
    profile,
  };
};

export default useDoctorProfile;
